<template>
    <div class="row q-mb-lg">
        <div class="col-xs-12 col-sm-4 text-h6" :class="$q.platform.is.desktop ? 'components-title' : ''">
            <q-skeleton type="text" />
        </div>

        <div class="col-12" v-if="$q.platform.is.desktop">
            <q-carousel v-model="slide" swipeable animated padding arrows infinite keep-alive transition-prev="slide-right" prev-icon="fal fa-angle-left" transition-next="slide-left" next-icon="fal fa-angle-right" control-color="grey-7" class="no-shadow" height="auto">
                <q-carousel-slide :name="index + 1" class="column no-wrap" v-for="(page, index) in paginatedCourses" :key="`p${index}`">
                    <div class="row q-col-gutter-md">
                        <div class="col-3" v-for="(course, index) in page" :key="`i${index}`">
                            <q-card class="full-width relative-position cursor-pointer">
                                <q-skeleton height="200px" square />

                                <q-card-section>
                                    <q-skeleton type="text" />
                                    <q-skeleton type="text" />
                                </q-card-section>
                            </q-card>
                        </div>
                    </div>
                </q-carousel-slide>
            </q-carousel>
        </div>

        <div class="col-12" v-if="$q.platform.is.mobile">
            <q-scroll-area horizontal :visible="false" class="scroll-hidden q-mt-md scroll-area-height-portfolio">
                <div class="row no-wrap q-col-gutter-md" style="max-width: 100vw;">
                    <div class="col-xs-5 col-sm-3" v-for="(course, index) in group_trainings" :key="`i${index}`">
                        <q-card class="full-width relative-position cursor-pointer" style="max-height: 210px;">
                            <q-skeleton height="100px" square />

                            <q-card-section>
                                <q-skeleton type="text" />
                                <q-skeleton type="text" />
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </q-scroll-area>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AreaSkeletonPortfolio',

    data() {
        return {
            slide: 1,
            group_trainings: [
                {},{},{},{},{},{},{},{}
            ]
        }
    },

    computed: {
        paginatedCourses() {
            let chunks = []
            let group_trainings = [
                {},{},{},{},{},{},{},{}
            ]
            let i = 0
            let n = this.group_trainings.length

            while (i < n) chunks.push(this.group_trainings.slice(i, i += 4))
            return chunks
        }
    },
}
</script>

<style>

</style>